import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { ALL_PAGES } from '@/lib/policyContent';
import { Panel, SectionDivider } from '@/components/Panel';
import { HeritageSeal } from '@/components/BrandMark';

export default function PolicyPage({ pageKey }) {
  const params = useParams();
  const key = pageKey || params.pageKey;
  const page = ALL_PAGES[key];
  if (!page) return <Navigate to="/" replace />;

  return (
    <div className="max-w-4xl mx-auto px-6 py-14">
      <div className="text-center">
        <HeritageSeal size={72} />
        <div className="h-eyebrow mt-4">{page.eyebrow}</div>
        <h1 className="h-display text-4xl md:text-5xl mt-2" style={{ color: 'var(--heritage-plum)' }}>{page.title}</h1>
        {page.intro && (
          <p className="max-w-2xl mx-auto mt-4 opacity-85 leading-relaxed" style={{ color: 'var(--heritage-plum)' }}>{page.intro}</p>
        )}
      </div>

      <SectionDivider />

      <Panel className="p-8 md:p-10">
        <div className="space-y-6">
          {page.sections.map((s) => (
            <section key={s.h}>
              <h2 className="h-serif text-2xl mb-2" style={{ color: 'var(--heritage-plum)' }}>{s.h}</h2>
              {s.p.map((para, j) => (
                <p key={`${s.h}-${j}`} className="text-sm leading-relaxed opacity-90 mb-2" style={{ color: 'var(--heritage-plum)' }}>{para}</p>
              ))}
            </section>
          ))}
        </div>
        <div className="h-divider my-8" />
        <p className="text-xs opacity-70" style={{ color: 'var(--heritage-plum)' }}>
          Heritage Dahlias NZ Limited. Aotearoa, New Zealand. Nothing in this document limits any right you have under the Consumer Guarantees Act 1993, Fair Trading Act 1986, or Privacy Act 2020.
        </p>
      </Panel>
    </div>
  );
}
